const BASE = process.env.REACT_APP_API_URL || '';

async function request(path, options = {}) {
  const token      = localStorage.getItem('token');
  const accessCode = localStorage.getItem('lc_access_code');
  const res = await fetch(`${BASE}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token      ? { Authorization: `Bearer ${token}` } : {}),
      ...(accessCode ? { 'X-Access-Code': accessCode }      : {}),
      ...options.headers,
    },
    ...options,
  });

  if (res.status === 401) {
    localStorage.removeItem('token');
    window.location.href = '/login';
    return;
  }

  if (res.status === 204) return null;

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
}

export const api = {
  // Auth
  register: (body) => request('/api/auth/register', { method: 'POST', body: JSON.stringify(body) }),
  login:    (body) => request('/api/auth/login',    { method: 'POST', body: JSON.stringify(body) }),

  // Dashboard
  dashboard: () => request('/api/dashboard'),

  // Properties
  getProperties:    ()       => request('/api/properties'),
  createProperty:   (body)   => request('/api/properties', { method: 'POST', body: JSON.stringify(body) }),
  getProperty:      (id)     => request(`/api/properties/${id}`),
  updateProperty:   (id, b)  => request(`/api/properties/${id}`, { method: 'PUT', body: JSON.stringify(b) }),
  deleteProperty:   (id)     => request(`/api/properties/${id}`, { method: 'DELETE' }),

  // Certificates
  getCertificates:  (propID) => request(`/api/properties/${propID}/certificates`),
  createCertificate:(propID, b) => request(`/api/properties/${propID}/certificates`, { method: 'POST', body: JSON.stringify(b) }),
  updateCertificate:(id, b)  => request(`/api/certificates/${id}`, { method: 'PUT', body: JSON.stringify(b) }),
  deleteCertificate:(id)     => request(`/api/certificates/${id}`, { method: 'DELETE' }),

  // Tenants
  getTenants:   (propID)   => request(`/api/properties/${propID}/tenants`),
  createTenant: (propID, b) => request(`/api/properties/${propID}/tenants`, { method: 'POST', body: JSON.stringify(b) }),
  updateTenant: (id, b)    => request(`/api/tenants/${id}`, { method: 'PUT', body: JSON.stringify(b) }),
  deleteTenant: (id)       => request(`/api/tenants/${id}`, { method: 'DELETE' }),

  // AI & Licensing
  checkTenancy:   (body) => request('/api/ai/check-tenancy',  { method: 'POST', body: JSON.stringify(body) }),
  checkLicensing: (body) => request('/api/licensing/check',   { method: 'POST', body: JSON.stringify(body) }),

  // Reminders
  getReminders: () => request('/api/reminders'),

  // HMO
  getHMODashboard:    ()         => request('/api/hmo/dashboard'),
  getHMOLicences:     (propID)   => request(`/api/properties/${propID}/hmo-licences`),
  createHMOLicence:   (propID, b)=> request(`/api/properties/${propID}/hmo-licences`, { method: 'POST', body: JSON.stringify(b) }),
  updateHMOLicence:   (id, b)    => request(`/api/hmo-licences/${id}`, { method: 'PUT', body: JSON.stringify(b) }),
  deleteHMOLicence:   (id)       => request(`/api/hmo-licences/${id}`, { method: 'DELETE' }),

  // RRA compliance
  rraDashboard:          ()        => request('/api/rra/dashboard'),
  getPossessionGrounds:  ()        => request('/api/possession-grounds'),
  updateInfoSheet:       (id, b)   => request(`/api/tenants/${id}/info-sheet`, { method: 'PUT', body: JSON.stringify(b) }),
  getRentReviews:        (propID)  => request(`/api/properties/${propID}/rent-reviews`),
  createRentReview:      (propID, b) => request(`/api/properties/${propID}/rent-reviews`, { method: 'POST', body: JSON.stringify(b) }),
  updateRentReview:      (id, b)   => request(`/api/rent-reviews/${id}`, { method: 'PUT', body: JSON.stringify(b) }),
  getPetRequests:        (propID)  => request(`/api/properties/${propID}/pet-requests`),
  createPetRequest:      (propID, b) => request(`/api/properties/${propID}/pet-requests`, { method: 'POST', body: JSON.stringify(b) }),
  updatePetRequest:      (id, b)   => request(`/api/pet-requests/${id}`, { method: 'PUT', body: JSON.stringify(b) }),
  getPossessionNotices:  (propID)  => request(`/api/properties/${propID}/possession-notices`),
  createPossessionNotice:(propID, b) => request(`/api/properties/${propID}/possession-notices`, { method: 'POST', body: JSON.stringify(b) }),
};